import React, { useState, useContext, MouseEvent, useEffect, useCallback } from 'react';
import GameConfigContext, { GameConfigProps, TileProps } from '../../../contexts/GameConfigContext/GameConfigContext';
import { TileBox, HiddenContent, TileInner, Boom, Flag } from './Tile.css';
import ClicksCounter from '../../../contexts/ClicksCounter';

const Tile = (props: TileProps & { x:number; y: number}): JSX.Element => {
  const { gameConfig, setGameConfig, showTileByXY, createTiles, tileDoubleClicked, markAllAround } = useContext(GameConfigContext);
  const [ markedAsBomb, setMarkedAsBomb ] = useState(props.flagged);
  const [isMouseDown, setIsMouseDown] =  useState(false);

  useEffect(() => {
    // if (gameConfig.reloaded) {
      console.log('reloaded');
      setMarkedAsBomb(false);
      setIsMouseDown(false);
    // }
  }, [gameConfig.reloaded]);

  useEffect(() => {
    if (props.isMouseDown !== undefined) {
      setIsMouseDown(props.isMouseDown);
    }
  }, [props.isMouseDown])

  const handleMarkBomb = useCallback((event: MouseEvent<HTMLDivElement>) => {
    if('preventDefault' in event)
      event.preventDefault();
    if (gameConfig.gameOver || !gameConfig.tiles[props.x][props.y].hidden) {
      return;
    }
    if (gameConfig.flagCount >= gameConfig.bombCount && !markedAsBomb) {
      return;
    }

    console.log('mark flag');

    ClicksCounter.addClick();

    setMarkedAsBomb(!markedAsBomb);
    const flagCount = markedAsBomb ? gameConfig.flagCount - 1 : gameConfig.flagCount + 1;
    let correctCount = gameConfig.correctCount;
    let win = false;
    let reloaded = gameConfig.reloaded;
    let gameOver = false;
    if (gameConfig.tiles[props.x][props.y].bomb && !markedAsBomb) {
      correctCount++;
    }
    if (gameConfig.tiles[props.x][props.y].bomb && markedAsBomb) {
      correctCount--;
    }

    let flagTile = [...gameConfig.tiles];
    flagTile[props.x][props.y].flagged = !markedAsBomb;

    if (correctCount === gameConfig.bombCount && isEveryTileNotHidden()) {
      gameOver = true;
      win = true;
      reloaded = !reloaded;
      // odkryj bomby
      flagTile = flagTile.map((tile:TileProps[]) => tile.map((til:TileProps) => {
        return til.bomb ? {...til, hidden: false, flagged: false} : til;
      }));
    }

    setGameConfig({...gameConfig, tiles: flagTile, flagCount, correctCount, win, gameOver, reloaded, started: true});
    return false;
  }, [gameConfig]);

  const isEveryTileNotHidden = useCallback(() => {
    let result = true;
    for (let x = 0; x < gameConfig.areaTilesHeightNum; x++) {
      for (let y = 0; y < gameConfig.areaTilesWidthNum; y++) {
        if (gameConfig.tiles[x][y].hidden && !gameConfig.tiles[x][y].bomb) {
          result = false;
        }
      }
    }
    return result;
  }, [gameConfig.tiles])

  const handleShowTile = useCallback((event: React.MouseEvent<HTMLElement>) => {
    if (gameConfig.gameOver || gameConfig.tiles[props.x][props.y].flagged || event.button > 0) {
      return;
    }

    let newTiles = gameConfig.tiles;

    if (gameConfig.started === false) {
      console.log('first pick');
      ClicksCounter.reset();
      newTiles = createTiles(gameConfig, {x: props.x, y: props.y});
    }

    ClicksCounter.addClick();

    markAllAround(props.x, props.y, false);

    setIsMouseDown(false);

    const copyTiles = showTileByXY(props.x, props.y, [...newTiles], 0) as { tiles: TileProps[][], gameOver: boolean, flagCount: number };

    let win = false;
    let reloaded = gameConfig.reloaded;

    if (isEveryTileNotHidden()) {
      copyTiles.gameOver = true;
      win = true;
      reloaded = !reloaded;
      copyTiles.tiles = copyTiles.tiles.map((tile:TileProps[]) => tile.map((til:TileProps) => {
        return til.bomb ? {...til, hidden: false, flagged: false} : til;
      }));
    }

    setGameConfig((gc: GameConfigProps) => {
      return {...gc, tiles: copyTiles.tiles, flagCount: copyTiles.flagCount, gameOver: copyTiles.gameOver, started: true, win, reloaded}
    });
  }, [gameConfig]);

  const handleMouseLeave = () => {
    setIsMouseDown(false);
    // markAllAround(props.x, props.y, false);
  };

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    if (window.isMouseDown && event.button === 0 && (!gameConfig.gameOver && !gameConfig.tiles[props.x][props.y].flagged)) {
      setIsMouseDown(true);
    }
  };

  const handleMouseDown = (event: React.MouseEvent<HTMLElement>) => {
    if (event.button === 0 && !gameConfig.gameOver)
      setIsMouseDown(true);
  }

  const handleDoubleClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  }

  const handleMouseDown2 = (event: React.MouseEvent<HTMLElement>) => {
    if (gameConfig.tiles[props.x][props.y].hidden === false && event.button === 0/* 0 = left button */) {
      markAllAround(props.x, props.y, true);
      tileDoubleClicked(props.x, props.y);
    }
  }

  return (
    <TileBox size={gameConfig.tileSize} onMouseDown={handleMouseDown2} onDoubleClick={handleDoubleClick} onClick={handleMouseDown} onMouseUp={handleShowTile} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onContextMenu={handleMarkBomb}>
      <TileInner mouseDown={isMouseDown} size={gameConfig.tileSize}>
        {markedAsBomb && <Flag size={gameConfig.tileSize} />}
      </TileInner>
      {(props.bomb && !props.hidden) && <Boom size={gameConfig.tileSize} />}
      {(!props.hidden && !props.bomb) && <HiddenContent size={gameConfig.tileSize} count={props.bombsNear}></HiddenContent>}
    </TileBox>
  );
};

export default Tile;
